import { Link } from 'react-router'

export function NotFoundPage() {
  return (
    <div className="err-wrap">
      <div className="err">
        <div className="err-code">404</div>
        <div className="err-icon-line">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="11" cy="11" r="8" /><path d="M21 21l-4.35-4.35" />
          </svg>
          Не нашли
        </div>
        <h1 className="err-title">
          Этой страницы <em>нет</em>
        </h1>
        <p className="err-text">
          Возможно ссылка устарела или вы ошиблись адресом. Вернитесь на дашборд или напишите нам.
        </p>
        <div className="err-actions">
          <Link to="/dashboard" className="err-btn err-btn-primary">На дашборд</Link>
          <a
            className="err-btn err-btn-ghost"
            href="https://max.ru/u/f9LHodD0cOJxyFsfUc55-mWzIyVtOnWwMlagPfClMqClINEKzphlsr_6FQY"
            target="_blank"
            rel="noopener noreferrer"
          >
            Поддержка
          </a>
        </div>
      </div>
      <ErrStyles />
    </div>
  )
}

export function ErrStyles() {
  return (
    <style>{`
      .err-wrap {
        min-height: 100vh;
        display: flex; align-items: center; justify-content: center;
        padding: 32px;
        background: var(--tg-paper, #fafafd);
        font-family: var(--tg-font-ui, Inter, sans-serif);
      }
      .err {
        text-align: center;
        max-width: 440px;
        margin: 0 auto;
        padding: 8px 0;
      }
      .err-code {
        font-weight: 800; font-size: 72px; line-height: 1;
        letter-spacing: -0.04em;
        background: linear-gradient(180deg, var(--tg-ink) 0%, color-mix(in srgb, var(--tg-ink) 65%, transparent) 100%);
        -webkit-background-clip: text; background-clip: text;
        -webkit-text-fill-color: transparent;
        margin: 0 0 4px;
        font-variant-numeric: tabular-nums;
      }
      .err-code.warn {
        background: linear-gradient(180deg, #c25a14, #ed8a3c);
        -webkit-background-clip: text; background-clip: text;
      }
      .err-code.danger {
        background: linear-gradient(180deg, var(--tg-down), #ee6e3e);
        -webkit-background-clip: text; background-clip: text;
      }
      .err-icon-line {
        display: inline-flex; align-items: center; gap: 8px;
        font-size: 13px; font-weight: 700;
        color: var(--tg-mute);
        text-transform: uppercase; letter-spacing: 0.1em;
        margin-bottom: 14px;
      }
      .err-icon-line svg { width: 14px; height: 14px; }
      .err-title {
        font-size: 22px; font-weight: 800;
        letter-spacing: -0.018em; color: var(--tg-ink);
        margin: 8px 0 10px;
      }
      .err-title em {
        font-family: var(--tg-font-italic); font-style: italic; font-weight: 400;
        color: var(--tg-blue);
      }
      .err-text {
        font-size: 14px; color: var(--tg-mute);
        line-height: 1.55; margin: 0 0 20px;
      }
      .err-text b { color: var(--tg-ink-2); font-weight: 600; }
      .err-meta {
        font-size: 11.5px; color: var(--tg-mute-2);
        margin-top: 14px;
        font-family: var(--tg-font-mono, ui-monospace, monospace);
      }
      .err-actions {
        display: inline-flex; gap: 8px; flex-wrap: wrap; justify-content: center;
      }
      .err-btn {
        display: inline-flex; align-items: center; gap: 8px;
        padding: 10px 18px;
        border-radius: var(--tg-r-md, 10px);
        font-family: inherit;
        font-weight: 700; font-size: 14px;
        text-decoration: none;
        border: 1px solid transparent;
        cursor: pointer;
      }
      .err-btn svg { width: 14px; height: 14px; }
      .err-btn-primary { background: var(--tg-blue, #0080ff); color: white; }
      .err-btn-primary:hover { background: var(--tg-blue-hover, #0066cc); }
      .err-btn-ghost {
        background: var(--tg-surface, #fff);
        color: var(--tg-ink-2);
        border-color: var(--tg-line-2);
      }
      .err-btn-ghost:hover {
        background: var(--tg-surface-2);
        border-color: var(--tg-line);
        color: var(--tg-ink);
      }
    `}</style>
  )
}
